<template>
    <div class="panel">
        <div class="panel-heading">
            <div class="panel-label">
                <h3>Payment</h3></div>
        </div>
        <div class="panel-body">
            <div class="alert alert-secondary">
                <div class="alert-text"> Payment method</div>
            </div>
            <div class="row form-group payment">
                <div class="col-3">
                    <label class="input-label">Payment method type</label>
                </div>

                <div class="col-9">
                    <el-select :value="currentPaymentMethod" filterable placeholder="Payment method"
                               v-on:change="($event) => change($event)" >
                        <el-option
                            v-for="(option, optionsIndex) in paymentMethods"
                            :key="optionsIndex"
                            :label="option"
                            :value="option">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    name: "Payment",
    props: {
        id: {
            type: String
        },
    },
    data() {
        return {
            paymentMethods: ['cash', 'stripe']
        }
    },
    async created() {
         await this.GetShopPaymentMethodById(this.id);
    },
    methods: {
        ...mapActions(['GetShopPaymentMethodById']),
        ...mapMutations(['setPaymentMethod']),
        change (paymentMethod) {
            this.setPaymentMethod(paymentMethod)
        }
    },
    computed: {
        ...mapGetters({
            currentPaymentMethod: 'paymentMethod',
        }),
    }
}
</script>

<style scoped>
.payment {
    align-items: center;
}
</style>
